module.exports = __webpack_public_path__ + "static/media/tornado.0343d754.svg";